import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '@/features/auth/authSlice';
import profileReducer from '@/features/profile/profileSlice';
import themeReducer from '@/shared/theme/themeSlice';
import uiReducer from '@/shared/ui/uiSlice';
import doohReducer from '@/features/dooh/doohReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  profile: profileReducer,
  theme: themeReducer,
  ui: uiReducer,
  dooh: doohReducer,
});

export default rootReducer;
